<template>
    <v-app>
        <v-app-bar dark app class="primary" v-if="$root.user">
            <v-toolbar-title class="headline pr-5">
                <span class="white--text">Hauge Maskin</span>
            </v-toolbar-title>

            <v-toolbar-items>
                <v-btn text :to="{name: 'Report'}">Rapportering</v-btn>
                <v-btn text :to="{name: 'Offers'}">Tilbud</v-btn>
                <v-btn text :to="{name: 'Amendments'}">Endringsmeldinger</v-btn>
                <v-btn text :to="{name: 'AdminCost'}">Adm.kost.</v-btn>
            </v-toolbar-items>

            <v-spacer/>
            <v-btn text dark @click="$root.logout">
                Logg ut {{ $root.user.username }}
                <v-icon right>arrow_forward</v-icon>
            </v-btn>
        </v-app-bar>

        <v-content>
            <router-view/>
        </v-content>

        <v-snackbar
                v-for="message in $root.messages"
                :key="message.key"
                :timeout="3000"
                v-model="message.visible"
                :color="message.type"
                top>
            {{ message.message }}
            <v-btn dark icon @click.native="message.visible = false">
                <v-icon>close</v-icon>
            </v-btn>
        </v-snackbar>
    </v-app>
</template>

<script>

    export default {
        name: 'App',
        created() {
            if (this.$route.name !== 'Login') {
                this.$http.get('auth/user/').then(response => {
                    this.$router.replace({name: 'Report'});
                    this.$root.user = response.data;
                }).catch(() => {
                    this.$router.replace({name: 'Login'});
                });
            }
        },
        data() {
            return {
                //
            }
        }
    }
</script>

<style>
    .table-condensed th, .table-condensed td {
        padding: 0 12px !important;
    }

    .table-condensed td {
        height: 34px !important;
        border-left: 1px solid rgba(0, 0, 0, 0.1);
        border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    }

    .table-condensed tbody td:first-child {
        border-left: 0;
    }
</style>